import { gql } from "@apollo/client";

export const GET_NEGOTIATION_STRATEGY = gql`
	query NegotiationStrategy($negotiationId: Int!, $supplierId: Int!) {
		negotiationStrategy(negotiationId: $negotiationId, supplierId: $supplierId) {
			id
			negotiationId
			supplierId
			targetPriceReasoning
			batna
			confidenceLevel
			ourLeverage
			supplierLeverage
			powerBalance
			powerBalanceReasoning
			buyerPowerScore
			supplierPowerScore
			powerDifferential
			ourPowerSummary
			supplierPowerSummary
			powerDynamicsAssessment {
				id
				party
				question
				answer
				reasoning
				score
			}
			negotiationApproach
			approachSummary
			currentSegment
			targetSegment
			segmentRationale
			valueClaim
			valueCreation
			relationshipDepth
			sourcingProducts {
				tenderSourcingProductId
				tenderId
				variantId
				productDescription
				display
				displayId
				displayDescription
				caseQuantity
				displayQuantity
				sourcingQuantity
				sourcingCountry
				bids {
					bidId
					tenderId
					supplierId
					supplierCode
					supplierName
					price
					quantity
					unitOfMeasure
					currency
					packageCost
					logisticCost
					exwPrice
					totalDdpPrice
					deliveryLocation
					paymentTerm
					rebateOffer
					volumeDiscount
					offeredIncoterm
					productDescription
					countryOfOrigin
					materialNumber
					country
					bidRound
					isCurrent
					submittedAt
				}
				target {
					mdo
					laa
					supplierTarget
					openingTarget
					internalTarget
					currentBidPrice
					currency
					openingAllocation
					targetAllocation
					batna
					reasoning {
						targetPriceReasoning
						llmReasoning
					}
				}
			}
			displayGroups {
				display
				displayId
				displayDescription
				totalCaseQuantity
				mixPrice
				mixPriceCurrency
				variants {
					tenderSourcingProductId
					variantId
					variant
					productDescription
					caseQuantity
					displayQuantity
					sourcingCountry
					sourcingQuantity
					bidPrice
					bidCurrency
					target {
						mdo
						laa
						supplierTarget
						openingTarget
						internalTarget
						currentBidPrice
						currency
						openingAllocation
						targetAllocation
						batna
						reasoning {
							targetPriceReasoning
							llmReasoning
						}
					}
				}
			}
		}
	}
`;

export const GET_NEGOTIATION_TARGETS = gql`
	query NegotiationTargets($strategyId: Int!) {
		negotiationTargetsByStrategy(strategyId: $strategyId) {
			id
			negotiationId
			supplierId
			parameterName
			objective
			leverageLevel
			rationale
		}
	}
`;

export const GET_NEGOTIATION_TACTICS = gql`
	query NegotiationTactics($negotiationId: Int!, $supplierId: Int!) {
		negotiationTactics(negotiationId: $negotiationId, supplierId: $supplierId) {
			id
			negotiationId
			supplierId
			parameterName
			maximumConcession
			requiredTradeOff
			walkAwayPoint
			concessionRationale
		}
	}
`;

export const GET_NEGOTIATION_ALTERNATIVES = gql`
	query NegotiationAlternatives($strategyId: Int!) {
		negotiationAlternativesByStrategy(strategyId: $strategyId) {
			id
			negotiationId
			supplierId
			parameterName
			maximumConcession
			requiredTradeOff
			walkAwayPoint
			concessionRationale
		}
	}
`;

export const GET_POWER_DYNAMICS_SCORE = gql`
	query PowerDynamicsScore($negotiationId: Int!, $supplierId: Int!, $tenderId: Int) {
		powerDynamicsScore(negotiationId: $negotiationId, supplierId: $supplierId, tenderId: $tenderId)
	}
`;

export const NEGOTIATION_STRATEGY_SUBSCRIPTION = gql`
	subscription NegotiationStrategyUpdated($negotiationId: Int!, $supplierId: Int!) {
		negotiationStrategyUpdated(negotiationId: $negotiationId, supplierId: $supplierId) {
			__typename
			id
			negotiationId
			supplierId
			targetPriceReasoning
			batna
			confidenceLevel
			ourLeverage
			supplierLeverage
			powerBalance
			powerBalanceReasoning
			buyerPowerScore
			supplierPowerScore
			powerDifferential
			ourPowerSummary
			supplierPowerSummary
			powerDynamicsAssessment {
				id
				party
				question
				answer
				reasoning
				score
			}
			negotiationApproach
			approachSummary
			currentSegment
			targetSegment
			segmentRationale
			valueClaim
			valueCreation
			relationshipDepth
			sourcingProducts {
				tenderSourcingProductId
				tenderId
				variantId
				productDescription
				display
				displayId
				displayDescription
				caseQuantity
				displayQuantity
				sourcingQuantity
				sourcingCountry
				bids {
					bidId
					tenderId
					supplierId
					supplierCode
					supplierName
					price
					quantity
					unitOfMeasure
					currency
					packageCost
					logisticCost
					exwPrice
					totalDdpPrice
					deliveryLocation
					paymentTerm
					rebateOffer
					volumeDiscount
					offeredIncoterm
					productDescription
					countryOfOrigin
					materialNumber
					country
					bidRound
					isCurrent
					submittedAt
				}
				target {
					mdo
					laa
					supplierTarget
					openingTarget
					internalTarget
					currentBidPrice
					currency
					openingAllocation
					targetAllocation
					batna
					reasoning {
						targetPriceReasoning
						llmReasoning
					}
				}
			}
			displayGroups {
				display
				displayId
				displayDescription
				totalCaseQuantity
				mixPrice
				mixPriceCurrency
				variants {
					tenderSourcingProductId
					variantId
					variant
					productDescription
					caseQuantity
					displayQuantity
					sourcingCountry
					sourcingQuantity
					bidPrice
					bidCurrency
					target {
						mdo
						laa
						supplierTarget
						openingTarget
						internalTarget
						currentBidPrice
						currency
						openingAllocation
						targetAllocation
						batna
						reasoning {
							targetPriceReasoning
							llmReasoning
						}
					}
				}
			}
		}
	}
`;
